import React from 'react';

import classnames from 'classnames';
import { connect } from 'react-redux';

import ActionButton from 'components/ActionButton';
import Loading from 'components/Loading';
import { IAppState } from "types/app";

export interface IStorylet {
}

export interface Props {
  data: IStorylet,
  forceClearQreqs: boolean,
  isChoosing: boolean,
  isWorking: boolean,
  onChoose: () => void,
  qualityRequirements: React.ReactNode,
}

function StoryletButtonsAndQreqs(props: Props) {
  const {
    data,
    forceClearQreqs,
    isChoosing,
    isWorking,
    onChoose,
    qualityRequirements,
  } = props;
  return (
    <div
      className={classnames(
        'buttons storylet__buttons',
        forceClearQreqs && 'storylet__buttons--force-clear',
      )}
    >
      <ActionButton
        disabled={isChoosing}
        isWorking={isWorking}
        go
        data={data}
        onClick={onChoose}
      >
        {isWorking && <Loading spinner small />}
      </ActionButton>
      {qualityRequirements}
    </div>
  );
}

const mapStateToProps = ({ storylet: { isChoosing } }: IAppState) => ({ isChoosing });

export default connect(mapStateToProps)(StoryletButtonsAndQreqs);